import React, { useState } from "react";

/**
 * TagInput - Tag-based input matching the MultiSelectDropdown chip style.
 * Chips use: bg-primary bg-opacity-10 text-primary border border-primary
 *
 * Usage:
 *   <TagInput tags={col.dropdown_options} onChange={(tags) => ...} />
 */
const TagInput = ({ tags = [], onChange, placeholder = "Add option..." }) => {
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "," || e.key === "Enter") {
      e.preventDefault();
      const val = inputValue.trim().replace(/,$/, "");
      if (val && !tags.includes(val)) onChange([...tags, val]);
      setInputValue("");
    } else if (e.key === "Backspace" && !inputValue && tags.length > 0) {
      onChange(tags.slice(0, -1));
    }
  };

  return (
    <div>
      {/* Tags row */}
      {tags.length > 0 && (
        <div className="mb-2 d-flex flex-wrap gap-2 align-items-center">
          {tags.map((tag, idx) => (
            <span
              key={idx}
              className="badge bg-primary bg-opacity-10 text-primary border border-primary d-flex align-items-center gap-2"
              style={{ padding: "6px 10px", fontSize: "12px", fontWeight: 700 }}
            >
              {tag}
              <button
                type="button"
                className="btn-close"
                style={{ fontSize: "10px" }}
                aria-label={`Remove ${tag}`}
                onClick={() => onChange(tags.filter((t) => t !== tag))}
              />
            </span>
          ))}
        </div>
      )}

      {/* Input */}
      <input
        type="text"
        className="form-control form-control-sm"
        style={{ fontSize: "13px" }}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={tags.length === 0 ? placeholder : "Add more options..."}
      />


    </div>
  );
};

export default TagInput;
